import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const rbacPermissionEntity: Entity = {
  model: model,
  repository: repository,
}

export default rbacPermissionEntity
